import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/aceites/indica_tu_ubicacion.gif")